import styled from "styled-components";
import theme from "../../theme";

export const MenucheffId = styled.div`
    font-size: 10px;
    font-weight: 600;
    color: #f00;
`

export const NavItem = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 10px;
`

export const SoonBadge = styled.span`
    margin-left: 8px;
    padding: 1px 7px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #8a6d1f;
    background: #ffeab0;
    vertical-align: middle;
`

export const styles = {
    marginBottom: 10,
    navbar: {
      position: 'fixed',
      width: '100%',
      top: 0,
      zIndex: 999,
    },
    content: {
      width: '100%',
    },
  };

export const DrawerHeader = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 22px 20px 18px;
    background: var(--background-secondary-color);

    &::after {
        content: '';
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 1px;
        background: currentColor;
        opacity: 0.08;
    }
`;

export const DrawerAvatar = styled.div`
    width: 46px;
    height: 46px;
    flex-shrink: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 15px;
    color: ${theme.cores.white};
    background: linear-gradient(135deg, ${theme.cores.login} 0%, #8f5ff0 100%);
    box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.55);
`;

export const DrawerGreeting = styled.div`
    min-width: 0;
`;

export const DrawerGreetingName = styled.p`
    margin: 0;
    font-size: 14.5px;
    font-weight: 700;
    color: var(--text-color);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DrawerGreetingSub = styled.p`
    margin: 2px 0 0;
    font-size: 11.5px;
    color: var(--text-secondary-color);
    opacity: 0.75;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const SectionLabel = styled.div`
    padding: 16px 20px 6px;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.1px;
    text-transform: uppercase;
    color: var(--text-secondary-color);
    opacity: 0.7;
`;
